import { DatePicker, defaultDatePickerStrings, Label, Text } from '@fluentui/react';
import { textProp } from 'global/Application';
import { formatDate, parseDate } from 'global/Utility/TSFunctions';
import { IDateValue } from 'model/FlexibleAttributeModel';
import React, { useEffect, useState } from 'react';



interface IProps<T> {
    label?: string;
    disabled?: boolean;
    fieldValueOnChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: T) => void;
    defaultFieldValue?: T;
}

const DatePickerControl: React.FunctionComponent<IProps<IDateValue | null>> = (props) => {
    const { label, disabled } = props

    const withoutTimezone = true;

    const _parseDate = (date: string) => {
        // console.log('_parseDate', date);

        // blank/null/undefined string
        if (!date)
            return null;

        const dateObj = parseDate(date, withoutTimezone ? "local:yyyy-MM-dd" : "iso");

        // checking 'Invalid Date' object state
        if (dateObj.getTime() !== dateObj.getTime())
            return null;

        return dateObj;
    }

    const onFormatDate = (date?: Date): string => {
        // console.log('onFormatDate', date);

        if (!date)
            return '';

        const dateStr = date.toLocaleDateString();

        // fluent ui crashes on invalid date, for now setting an empty string onFormat is only option I can think of
        {
            const dateFormatTest = parseDate(formatDate(date, 'local:yyyy-MM-dd'), "local:yyyy-MM-dd");
            if (dateFormatTest.getTime() !== dateFormatTest.getTime())
                return '';
        }

        return dateStr;
    };

    const [dateValue, setDateValue] = useState<Date | null>(
        props.defaultFieldValue?.value
            ? _parseDate(props.defaultFieldValue.value)
            : null
    );

    useEffect(() => {
        setDateValue(props.defaultFieldValue?.value
            ? _parseDate(props.defaultFieldValue.value)
            : null
        );
    }, [props.defaultFieldValue?.value])


    const onChange = (date: Date | null | undefined) => {
        // console.log('onChange', date);

        const event = (null as unknown) as React.MouseEvent<HTMLElement, MouseEvent>;

        if (props.fieldValueOnChange) {

            let dateParsed = date ? formatDate(date, 'local:yyyy-MM-dd') : null;

            if (dateParsed) {
                const dateTest = _parseDate(dateParsed);

                // checking a successfully parsed date
                if (!dateTest)
                    dateParsed = null;

                // checking 'Invalid Date' object state
                if (dateTest && dateTest.getTime() !== dateTest.getTime())
                    dateParsed = null;
            }

            const value: (IDateValue | null) = dateParsed
                ? {
                    type: 'date',
                    value: dateParsed
                }
                : null;

            if (value && value.value)
                setDateValue(_parseDate(value.value));
            else
                setDateValue(null);

            props.fieldValueOnChange(event, value);

        }
    }


    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{(dateValue ? onFormatDate(dateValue) : null) ?? '---'}</Text>
        </div>;

    return (
        <div style={textProp.root.style}>
            <DatePicker
                allowTextInput
                label={label}
                formatDate={onFormatDate}
                placeholder="Select a date..."
                strings={defaultDatePickerStrings}
                onSelectDate={onChange}
                disabled={disabled}
                value={dateValue ?? undefined}
            />
        </div>
    )
}

export default DatePickerControl